import { Effect } from "../../../../../../../../../redux/types/effect.type";
import { ActionsObservable, StateObservable } from "redux-observable";
import { catchError, filter, map, mergeMap } from "rxjs/operators";
import { isActionType } from "../../../../../../../../../redux/action.functions";
import * as flyerDetailPageService from "../services/flyer-detail-page.services";
import { of } from "rxjs";
import { FlyerDetailPageFormPageActions } from "./flyer-detail-page-form-page.actions";
import * as actions from "./flyer-detail-page-form-page.actions";
import { RootState } from "../../../../../../../../../redux/store";
import * as flyerDetailPageStore from "../../../store/flyer-detail-page.store";
import { EffectActionsObservable } from "../../../../../../../../../redux/types/effect-actions-observable.type";
import { FlyerDetailPageActions } from "../../../store/flyer-detail-page.actions";
import * as flyerDetailPageActions from "../../../store/flyer-detail-page.actions";

const fetchPage: Effect = (action$: ActionsObservable<any>, state$: StateObservable<RootState>) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageFormPageActions.FetchPage)),
    map(() => flyerDetailPageStore.getPageId(state$.value)),
    mergeMap((pageId) =>
      flyerDetailPageService.fetchPage(pageId!).pipe(
        map(actions.fetchPageSuccess),
        catchError((error) => of(actions.fetchPageFailure(error)))
      )
    )
  );

const savePage: Effect = (action$: EffectActionsObservable, state$: StateObservable<RootState>) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageFormPageActions.SavePage)),
    map((action) => ({
      changes: action.payload,
      pageId: flyerDetailPageStore.getPageId(state$.value),
    })),
    mergeMap(({ pageId, changes }) =>
      flyerDetailPageService.savePage(pageId!, changes).pipe(
        map((result) => actions.savePageSuccess(result)),
        catchError((error) => of(actions.savePageFailure(error)))
      )
    )
  );

const savePageSuccess: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageFormPageActions.SavePageSuccess)),
    map((action) => action.payload),
    map((page) => flyerDetailPageActions.fetchPagePreview(page.id))
  );

const reset: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageActions.Reset)),
    map(() => actions.reset())
  );

export const FlyerDetailPageFormPageEffects = [fetchPage, savePage, reset, savePageSuccess];
